/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free daily water intake calculator. Estimate how much water to drink each day based on your body weight and how much you exercise.`)
};

const es_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de ingesta diaria de agua. Estima cuánta agua beber cada día según tu peso corporal y cuánto ejercicio haces.`)
};

const de_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Rechner für die tägliche Trinkmenge. Schätze, wie viel Wasser du täglich trinken solltest, basierend auf deinem Körpergewicht und deinem Trainingspensum.`)
};

const nl_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis calculator voor dagelijkse waterinname. Schat hoeveel water je per dag moet drinken op basis van je lichaamsgewicht en hoeveel je sport.`)
};

const fr_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit d'apport en eau quotidien. Estimez la quantité d'eau à boire chaque jour selon votre poids corporel et votre niveau d'exercice.`)
};

const it_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito dell'assunzione giornaliera di acqua. Stima quanta acqua bere ogni giorno in base al tuo peso corporeo e a quanto ti alleni.`)
};

const pt_br2_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de ingestão diária de água. Estime quanta água beber por dia com base no seu peso corporal e na quantidade de exercício que você faz.`)
};

const pt_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de ingestão diária de água. Estime quanta água beber por dia com base no seu peso corporal e no exercício que faz.`)
};

const ja_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の1日水分摂取量計算機。体重と運動量に基づいて、1日に飲むべき水の量を推定します。`)
};

const zh_water_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费每日饮水量计算器。根据你的体重和运动量，估算每天应该喝多少水。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_meta_description", locale)
	if (locale === "en") return en_water_meta_description(inputs)
	if (locale === "es") return es_water_meta_description(inputs)
	if (locale === "de") return de_water_meta_description(inputs)
	if (locale === "nl") return nl_water_meta_description(inputs)
	if (locale === "fr") return fr_water_meta_description(inputs)
	if (locale === "it") return it_water_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_water_meta_description(inputs)
	if (locale === "pt") return pt_water_meta_description(inputs)
	if (locale === "ja") return ja_water_meta_description(inputs)
	return zh_water_meta_description(inputs)
};